import type { State } from './type';

export const NOOPModal = () => null;

export const InitialState: State = {
  modal: NOOPModal,
}
